/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGetCredentialForEditOutput } from "../models/AjaxResponseOfGetCredentialForEditOutput";
import type { AjaxResponseOfGetCredentialForViewDto } from "../models/AjaxResponseOfGetCredentialForViewDto";
import type { AjaxResponseOfListOfCredentialVendorLookupTableDto } from "../models/AjaxResponseOfListOfCredentialVendorLookupTableDto";
import type { AjaxResponseOfListOfGetPortalForViewDto } from "../models/AjaxResponseOfListOfGetPortalForViewDto";
import type { AjaxResponseOfListOfPortalDto } from "../models/AjaxResponseOfListOfPortalDto";
import type { AjaxResponseOfPagedResultDtoOfCredentialPortalLookupTableDto } from "../models/AjaxResponseOfPagedResultDtoOfCredentialPortalLookupTableDto";
import type { AjaxResponseOfPagedResultDtoOfGetCredentialForViewDto } from "../models/AjaxResponseOfPagedResultDtoOfGetCredentialForViewDto";
import type { AjaxResponseOfString } from "../models/AjaxResponseOfString";
import type { CreateOrEditCredentialDto } from "../models/CreateOrEditCredentialDto";
import type { CreatePlatformsCredentialsInput } from "../models/CreatePlatformsCredentialsInput";
import type { PlatformsCredentialsInput } from "../models/PlatformsCredentialsInput";
import type { Portals } from "../models/Portals";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class CredentialsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfString
   * @throws ApiError
   */
  public createPlatformsCredentials({
    requestBody,
  }: {
    requestBody?: CreatePlatformsCredentialsInput;
  }): CancelablePromise<AjaxResponseOfString> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/credentials/create-platforms-credentials",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteSyncCmsCredentials({
    requestBody,
  }: {
    requestBody?: PlatformsCredentialsInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/credentials/delete-platforms-credentials",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfString
   * @throws ApiError
   */
  public authenticateFacebook({
    vendorId,
    site,
  }: {
    vendorId?: number;
    site?: string;
  }): CancelablePromise<AjaxResponseOfString> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/authenticate-facebook",
      query: {
        vendorId: vendorId,
        site: site,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEdit({
    requestBody,
  }: {
    requestBody?: CreateOrEditCredentialDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/credentials",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/credentials",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfGetCredentialForViewDto
   * @throws ApiError
   */
  public getAll({
    filter,
    vendorDisplayNameFilter,
    portalNameFilter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    vendorDisplayNameFilter?: string;
    portalNameFilter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfGetCredentialForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials",
      query: {
        filter: filter,
        vendorDisplayNameFilter: vendorDisplayNameFilter,
        portalNameFilter: portalNameFilter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfCredentialPortalLookupTableDto
   * @throws ApiError
   */
  public getAllPortalForLookupTable({
    filter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfCredentialPortalLookupTableDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-all-portal-for-lookup-table",
      query: {
        filter: filter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfGetPortalForViewDto
   * @throws ApiError
   */
  public getAllPortals({
    filter,
    nameFilter,
    credentialVendorId,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    nameFilter?: string;
    credentialVendorId?: number;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfListOfGetPortalForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-all-portals",
      query: {
        filter: filter,
        nameFilter: nameFilter,
        credentialVendorId: credentialVendorId,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfCredentialVendorLookupTableDto
   * @throws ApiError
   */
  public getAllVendorForTableDropdown(): CancelablePromise<AjaxResponseOfListOfCredentialVendorLookupTableDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-all-vendor-for-table-dropdown",
    });
  }

  /**
   * @returns AjaxResponseOfGetCredentialForEditOutput
   * @throws ApiError
   */
  public getCredentialForEdit({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfGetCredentialForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-credential-for-edit",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetCredentialForEditOutput
   * @throws ApiError
   */
  public loadCredentialForInsert({
    vendorId,
    portalId,
  }: {
    vendorId?: number;
    portalId?: number;
  }): CancelablePromise<AjaxResponseOfGetCredentialForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/load-credential-for-insert",
      query: {
        vendorId: vendorId,
        portalId: portalId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetCredentialForViewDto
   * @throws ApiError
   */
  public getCredentialForView({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfGetCredentialForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-credential-for-view",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public getPortalsPlans({
    portalCode,
    vendorId,
    zeroKmPlansOnly,
  }: {
    portalCode: Portals;
    vendorId?: number;
    zeroKmPlansOnly?: boolean;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-portals-plans",
      query: {
        portalCode: portalCode,
        vendorId: vendorId,
        zeroKmPlansOnly: zeroKmPlansOnly,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public getPortalsPlansMotorcycle({
    portalCode,
    vendorId,
    zeroKmPlansOnly,
  }: {
    portalCode: Portals;
    vendorId?: number;
    zeroKmPlansOnly?: boolean;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-portals-plans-motorcycle",
      query: {
        portalCode: portalCode,
        vendorId: vendorId,
        zeroKmPlansOnly: zeroKmPlansOnly,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfPortalDto
   * @throws ApiError
   */
  public portalsAllowedByVendor({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfListOfPortalDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/credentials/get-portals-allowed-by-vendor",
      query: {
        vendorId: vendorId,
      },
    });
  }

  /**
   * Reconciles portals released for tenant use with the selected vendor.
   * @returns any Success
   * @throws ApiError
   */
  public synchronizeAvailablePortalsForVendor({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/credentials/synchronize-available-portals",
      query: {
        vendorId: vendorId,
      },
    });
  }
}
